import { clsxm } from '@app/styles/clsxm';
import { useBannerHeightSync } from './hooks/useBannerHeightSync';
import { useTopBannerState } from './atoms/topBanner';
import { BuySubscriptionBanner } from '@app/domain/subscription/BuySubscriptionBanner';
import { OnboardingBanner } from '../onboarding/OnboardingBanner';
import { useActivePlan } from '@app/domain/plan/hooks/useActivePlan';
import { useAuthorizedUser } from '@app/auth/useAuthorizedUser';

type Props = {
  className?: string;
};

export const TopBanner: React.FC<Props> = ({ className }) => {
  const { isOldGenUser } = useAuthorizedUser();
  const { isTrial } = useActivePlan();
  const { shouldShowTopBanner } = useTopBannerState();

  const bannerRef = useBannerHeightSync();

  const renderContent = () => {
    if (shouldShowTopBanner) {
      if (isTrial) {
        return <OnboardingBanner className={className} />;
      }
      if (isOldGenUser) {
        return <BuySubscriptionBanner className={className} />;
      }
    }
  };

  const content = renderContent();
  if (!content) {
    return null;
  }

  return (
    <div ref={bannerRef} className={clsxm('h-auto', className)} data-testid="top-banner">
      {content}
    </div>
  );
};
